// extracted by mini-css-extract-plugin
export default {"privacyPolicyContainer":"privacyPolicy_privacyPolicyContainer__0+GDD","privacyPolicy":"privacyPolicy_privacyPolicy__xyU+B"};